import script from "./LoaderErrorBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoaderErrorBlock.vue?vue&type=script&setup=true&lang=ts"

import "./LoaderErrorBlock.vue?vue&type=style&index=0&id=ffc49838&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffc49838"]])

export default __exports__